export const TaskListingText = {
    CourseTopics: {
        en: "Course Topics",
        mr: "अभ्यासक्रमाचे विषय",
    },
    Previous: {
        en: "Previous",
        mr: "मागील",
    },
    Next: {
        en: "Next",
        mr: "पुढील",
    },
    MarkAsComplete: {
        en: "Mark as complete",
        mr: "पूर्ण झाले म्हणून चिन्हांकित करा",
    },
    StartTask: {
        en: "Start Task",
        mr: "सुरू करा",
    },
    ReDoTask: {
        en: "Re-Do Task",
        mr: "कार्य पुन्हा सुरू करा",
    },
    Continue: {
        en: "Continue",
        mr: "पुढे जा",
    },
    Completed: {
        en: "Completed",
        mr: "पूर्ण",
    },
};
